<template>
  <router-link :to="to" class="section-action">
    <CButton color="primary" variant="outline" size="sm">{{ label }}</CButton>
  </router-link>
</template>

<script>
/**
 * 自社設定の各カードから、その項目だけの編集画面へ入るボタン。
 *
 * <h2>なぜ部品にするのか</h2>
 *
 * <b>置き場所と見た目を、カードに決めさせない。</b>
 * 決めさせていたころは、同じ自社設定の中で保存や編集のボタンが
 * 右・左・中とばらばらに出ていて、押す場所を毎回探すことになっていた。
 *
 * ここが持てば、どのカードでも見出しの右端に同じ形で出る。
 */
export default {
  name: 'SettingSectionAction',
  props: {
    to: { type: Object, required: true },
    label: { type: String, default: '変更' }
  }
}
</script>

<style scoped>
/*
  見出しの右端へ寄せる。カード側は section-heading を
  display:flex にしているので、ここは自分の位置だけ決める。
*/
.section-action {
  margin-left: auto;
  align-self: flex-start;
  text-decoration: none;
}

/*
  **色は自分で決め切る。**

  workflow-rich.css に

    .preika-route-view--business > .card > .card-header:first-child .btn
    { background: rgba(255,255,255,.12); color: #fff; }

  がある。見出しが濃い背景の画面のためのもので、そこでは白が正しい。
  ところが自社設定はカードが縦に並ぶ画面で、**どのカードの見出しにも
  当たってしまう。**見出しは白いままなので、白い文字だけが残る。

  実測で9つとも color が rgb(255,255,255)、背景が白の上——
  つまり<b>押すべきボタンが1つも見えていなかった。</b>

  向こうの選択子は 6 クラスぶんの強さがあり、素直に書いても勝てない。
  勝ち負けを競うより、**この部品の見た目はこの部品が決める**と
  はっきりさせるほうが後から読める。だから !important を使う。
  向こうは !important を付けていないので、これで必ず勝つ。
*/
.section-action >>> .btn {
  border-color: var(--preika-blue-300, #8fbfe0) !important;
  background: #fff !important;
  color: var(--preika-blue-700, #0a6ca8) !important;
  backdrop-filter: none !important;
}

.section-action:hover >>> .btn,
.section-action:focus >>> .btn {
  border-color: var(--preika-blue-700, #0a6ca8) !important;
  background: var(--preika-blue-050, #eef7fc) !important;
}
</style>
